import { render, staticRenderFns } from "./SectionSubtitle.vue?vue&type=template&id=657268c6&scoped=true&"
import script from "./SectionSubtitle.vue?vue&type=script&lang=ts&"
export * from "./SectionSubtitle.vue?vue&type=script&lang=ts&"
import style0 from "./SectionSubtitle.vue?vue&type=style&index=0&id=657268c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657268c6",
  null
  
)

export default component.exports